import { useEffect } from "react";
import { useConfig } from "../containers/ConfigContext";
import { useNavigate } from "react-router-dom";

export default function ProductReportPage() {
  const { loggedUser } = useConfig();
  const navigate = useNavigate();

  useEffect(() => {
    if (loggedUser?.chartConfig === null) {
      navigate("/stores");
    } else if (loggedUser?.chartConfig?.pages.length) {
      navigate(`/charts/${loggedUser?.chartConfig?.pages[0].url}`);
    }
    // if undefined, waiting for loading chart config data
  }, [loggedUser?.chartConfig, navigate]);

  return (
    <div></div>
  );
}
